<template>
  <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <form @submit.prevent="handleSubmit">
      <div class="modal-window-header gray">
        <div class="modal-window-heading">
          <h3 class="icon-heading small">
            <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg></span>
            <span v-if="kunde.Bedrift && kunde.FirmaNavn">{{kunde.FirmaNavn}}<span class="opacity-60" v-if="kunde.full_name"> ({{kunde.full_name}})</span></span>
            <span v-else>{{kunde.full_name}}</span>
          </h3>
        </div>

        <fieldset>
          <div class="grid-x grid-padding-x">
            <TheTextInput containerClassName="cell large-12" label="E-post" name="Email" v-model.trim="form.Email" required v-validate="'required|email|kundeEmailUnique'">
              <label slot="label" slot-scope="props" :for="props.id">
                {{props.label}} * <span v-if="emailcheck"> søker...</span>
              </label>
            </TheTextInput>
            <ThePhoneInput containerClassName="cell large-4" label="Telefonnummer Privat" name="Tlfprivat" v-model.trim="form.Tlfprivat" maxlength="20" v-validate="'max:20'"/>
            <ThePhoneInput containerClassName="cell large-4" label="Telefonnummer Arbeid" name="Tlfarbeid" v-model.trim="form.Tlfarbeid" maxlength="20" v-validate="'max:20'"/>
            <ThePhoneInput containerClassName="cell large-4" label="Telefonnummer Mobil" name="Mobil" v-model.trim="form.Mobil" maxlength="20" v-validate="'max:20'"/>

            <TheIntegerInput containerClassName="cell large-12" label="Kontonummer" name="Kontonr" v-model.trim="form.Kontonr" v-validate="'min:11|max:11|kundeKontonrValidation'"/>

            <div class="cell large-12">
              <div class="input-container" :class="{'form-error': errors.has('min_one_phone')}">
                <input type="hidden" name="min_one_phone" v-model.trim="hasOnePhone" value="1" v-validate="'max:4'">
                <span class="form-error-label" v-if="errors.has('min_one_phone')">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                  Fyll inn minst en telefonnummer
                </span>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-body">
        <div class="cell large-12" v-if="!kunde.kundeadresse || kunde.kundeadresse.length < 1">
         <h2>Nåværende lagret adresse</h2>
             <div class="card">
               <dl>
                 <dt>Adresse1</dt>
                 <dd>{{kunde.Adresse1}}</dd>
                 <dt>Adresse2</dt>
                 <dd>{{kunde.Adresse2}}</dd>
                 <dt>Adresse3</dt>
                 <dd>{{kunde.Adresse3}}</dd>
                 <dt>Postnr / Poststed</dt>
                 <dd>{{kunde.Postnr}} / {{kunde.Poststed}}</dd>
               </dl>
             </div>
           </div>
        <fieldset>
          <h2>Fakturaadresse</h2>
          <div class="grid-x grid-padding-x">
            <TheTextInput containerClassName="cell large-4" label="Adressefelt 1" name="adresseFaktura-Adresse" v-model.trim="adresseFaktura.Adresse" maxlength="75" required v-validate="'required|max:75'"/>
            <TheTextInput containerClassName="cell large-4" label="Adressefelt 2" name="adresseFaktura-Adresse2" v-model.trim="adresseFaktura.Adresse2" maxlength="75" v-validate="'max:75'"/>
            <TheTextInput containerClassName="cell large-4" label="C/O" placeholder="Navn" name="adresseFaktura-Co" v-model.trim="adresseFaktura.Co" maxlength="75" v-validate="'max:75'"/>

            <TheTextInput containerClassName="cell small-4 large-4" label="Postnummer" name="adresseFaktura-Postnr" v-model.trim="adresseFaktura.Postnr" required :maxlength="adresseFaktura.Landkode === 'NO' ? '4' : '10'" v-validate="{ required: true, max: adresseFaktura.Landkode === 'NO' ? '4' : '10' }"/>
            <TheTextInput containerClassName="cell small-4 large-4" label="Poststed" name="adresseFaktura-Poststed" v-model.trim="adresseFaktura.Poststed" maxlength="75" required v-validate="'required|max:75'"/>

            <TheCountryInput v-model="adresseFaktura.Landkode" containerClassName="cell small-4 large-4" label="Land" name="adresseFaktura-Landkode" :items="instillinger.land" data-vv-validate-on="input" required v-validate="'required|min:1'" :disabled="this.$store.getters.isFormLoading"/>

            <div class="cell">
              <div class="input-container checkbox">
                <input type="checkbox" name="isSameaddress" id="isSameaddress" v-model="isSameaddress">
                <label for="isSameaddress">Fakturaadresse og leveringsadresse er like.</label>
                <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset v-if="!isSameaddress">
          <h2>Leveringsadresse</h2>
          <div class="grid-x grid-padding-x">
            <TheTextInput containerClassName="cell large-4" label="Adressefelt 1" name="adresseLevering-Adresse" v-model.trim="adresseLevering.Adresse" maxlength="75" v-validate="'max:75'"/>
            <TheTextInput containerClassName="cell large-4" label="Adressefelt 2" name="adresseLevering-Adresse2" v-model.trim="adresseLevering.Adresse2" maxlength="75" v-validate="'max:75'"/>
            <TheTextInput containerClassName="cell large-4" label="C/O" placeholder="Navn" name="adresseLevering-Co" v-model.trim="adresseLevering.Co" maxlength="75" v-validate="'max:75'"/>

            <TheTextInput containerClassName="cell small-4 large-4" label="Postnummer" name="adresseLevering-Postnr" v-model.trim="adresseLevering.Postnr" :maxlength="adresseLevering.Landkode === 'NO' ? '4' : '10'" v-validate="{ max: adresseLevering.Landkode === 'NO' ? '4' : '10' }"/>
            <TheTextInput containerClassName="cell small-4 large-4" label="Poststed" name="adresseLevering-Poststed" v-model.trim="adresseLevering.Poststed" maxlength="75" v-validate="'max:75'"/>

            <TheCountryInput v-model="adresseLevering.Landkode" containerClassName="cell small-4 large-4" label="Land" name="adresseLevering-Landkode" :items="instillinger.land" :disabled="this.$store.getters.isFormLoading"/>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-footer">
        <div class="grid-x">
          <div class="cell align-right">
            <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
            <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

            <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonClick()" class="button primary submit large">Lagre</a>
            <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Lagrer...<span class="loader-spinner"></span></a>
            <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Lagre</a>
          </div>
        </div>
      </div>

      <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
        <span>Lukk</span>
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
      </a>
    </form>
  </overlay-scrollbars>
</template>

<script>
import KundeService from '@/services/KundeService'
import InstillingerService from '@/services/InstillingerService'
import DummyCache from '@/plugins/dummy-cache.js'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeAdresseModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    kunde: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    },
    event: {
      type: String,
      required: false,
      default: () => {
        return 'kunde-address-updated'
      }
    }
  },
  data () {
    return {
      form: {},
      emailcheck: false,
      isSameaddress: true,
      adresseFaktura: {},
      adresseLevering: {},
      postnrList: [],
      instillinger: {
        land: [],
        legitimasjon: [],
        bruker: [],
        sprak: [
          { key: '', val: '- Velg språk -' },
          { key: 'nor-NO', val: 'Norsk' },
          { key: 'eng-GB', val: 'Engelsk' }
        ]
      }
    }
  },
  computed: {
    hasOnePhone: function () {
      if (this.form.Tlfprivat || this.form.Tlfarbeid || this.form.Mobil) {
        return true
      }

      return false
    }
  },
  watch: {
    'form.Tlfprivat': function (newVal) {
      if (newVal !== undefined) {
        this.$validator.validate('min_one_phone')
      }
    },
    'form.Tlfarbeid': function (newVal) {
      if (newVal !== undefined) {
        this.$validator.validate('min_one_phone')
      }
    },
    'form.Mobil': function (newVal) {
      if (newVal !== undefined) {
        this.$validator.validate('min_one_phone')
      }
    },
    'adresseFaktura.Postnr': function (newVal, oldVal) {
      if (this.adresseFaktura.Landkode === 'NO') {
        // Skip - if on load and not a norway
        if (newVal !== undefined) {
          if (!newVal || newVal.length !== 4) {
            this.adresseFaktura.Poststed = ''
          } else {
            let found = this.postnrList.find(x => '' + x.key === newVal)

            if (found) {
              this.adresseFaktura.Poststed = found.val
            } else if (oldVal !== undefined) {
              this.adresseFaktura.Poststed = ''
            }
          }
        }
      }
    },
    'adresseLevering.Postnr': function (newVal, oldVal) {
      if (this.adresseLevering.Landkode === 'NO') {
        if (newVal !== undefined && !this.sameaddress) {
          if (!newVal || newVal.length !== 4) {
            this.adresseLevering.Poststed = ''
          } else {
            let found = this.postnrList.find(x => '' + x.key === newVal)

            if (found) {
              this.adresseLevering.Poststed = found.val
            } else if (oldVal !== undefined) {
              this.adresseLevering.Poststed = ''
            }
          }
        }
      }
    }
  },
  created () {
    // Set form to loading
    this.setFormLoading(true)

    // Make the form object
    this.makeFormItem()

    // Add the kunde email unique rule to our validator
    this.$validator.extend('kundeEmailUnique', {
      validate: this.uniqueEmailCheck,
      getMessage: (field, params, data) => data ? data.message : 'Kunde med denne epost finnes allerede'
    })

    // Add the kunde kontonummer unique rule to our validator
    this.$validator.extend('kundeKontonrValidation', {
      validate: this.kontonrValidation,
      getMessage: (field, params, data) => data ? data.message : 'Virker som at Kontonummer ikke er gyldig'
    })

    // Create an emails cache container, so we don't have to do api requests if same email is sent tvice...
    this.emailsCache = new DummyCache()

    // Load data needed in the form
    this.fetch()
  },
  methods: {
    makeFormItem: function () {
      // Clone kunde to the form object
      this.form = this._.cloneDeep(this.kunde)

      // Prep addresse
      this.adresseFaktura = this._.find(this.form.kundeadresse, ['Type', 'faktura']) || {}
      this.adresseLevering = this._.find(this.form.kundeadresse, ['Type', 'levering']) || {}

      // Set default NO as land if not already set
      if (!this.adresseFaktura.Landkode) {
        this.adresseFaktura.Landkode = 'NO'
      }

      if (!this.adresseLevering.Landkode) {
        this.adresseLevering.Landkode = 'NO'
      }

      // Check if it is same address / for the checkbox
      if (this._.isEmpty(this.adresseLevering)) {
        this.isSameaddress = true
      } else {
        this.isSameaddress = this._.isEqual(
          this._.omit(this.adresseFaktura, ['id', 'Type']),
          this._.omit(this.adresseLevering, ['id', 'Type'])
        )
      }
    },
    fetch: function () {
      this.instillinger.land.unshift({key: this.form.Landkode, val: 'Laster...', disabled: true})

      InstillingerService('land').dropdown()
        .then((response) => {
          this.instillinger.land = response.data
          this.instillinger.land.unshift({key: null, val: '- Velg land -'})
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          // Now submittable again
          this.setFormLoading(false)
        })

      // Load Postnr
      InstillingerService('postreg').dropdown()
        .then((response) => {
          this.postnrList = response.data
          this.$validator.validateAll()
        })
        .catch((e) => {
          console.log(e)
          this.postnrList = []
        })
    },
    addAddressesToFormData: function () {
      // Prep addresse
      this.form.kundeadresse = []

      // We have no faktura - so create it
      if (this._.isEmpty(this.adresseFaktura) || !this.adresseFaktura.Type) {
        this.adresseFaktura.Type = 'faktura'

        if (this.kunde.Kundenr) {
          this.adresseFaktura.Kundenr = this.kunde.Kundenr
        }
      }

      // We have no levering - so create it
      if (this._.isEmpty(this.adresseLevering) || !this.adresseLevering.Type) {
        this.adresseLevering.Type = 'levering'

        if (this.kunde.Kundenr) {
          this.adresseLevering.Kundenr = this.kunde.Kundenr
        }
      }

      // Same address clicked
      if (this.isSameaddress) {
        this.adresseLevering = this._.merge(this.adresseLevering || {}, this._.omit(this.adresseFaktura, ['id', 'Type']))
      }

      this.form.kundeadresse.push(this.adresseFaktura)
      this.form.kundeadresse.push(this.adresseLevering)
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.setFormLoading(false)
        this.$emit('close')
      }
    },
    submitButtonClick: function () {
      this.handleSubmit()
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            // No errors, so try to save
            let kundenr = this.kunde.Kundenr || null

            // Add the addresses to the form data
            this.addAddressesToFormData()

            KundeService.save(kundenr, this.form)
              .then((response) => {
                this.$emit('close')
                bus.$emit(this.event, response.data)
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
                } else {
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst prøv igjen', 2500)
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    uniqueEmailCheck: function (value) {
      return new Promise(resolve => {
        // Compare to original value first, if save we allow it
        if (this.kunde.Email && value === this.kunde.Email) {
          resolve({valid: true})
          return
        }

        // Start email check
        this.emailcheck = true
        let promise = null

        // See if we have a cached email
        if (!(promise = this.emailsCache.get(value))) {
          promise = KundeService.findByEmail(value)
          this.emailsCache.set(value, promise)
        }

        // Now do the resolve/reject logic
        promise
          .then((response) => {
            if (response.data && response.data.Email === value) {
              resolve({valid: false, data: {message: 'Kunde med denne epost finnes allerede'}})
            } else {
              resolve({valid: true})
            }
          })
          .catch(() => {
            resolve({valid: true})
          })
          .then(() => {
            this.emailcheck = false
          })
      })
    },
    kontonrValidation: function (value) {
      return new Promise(resolve => {
        if (!value) {
          resolve({valid: false, data: {message: 'Kontonummer er påkrevd'}})
        } else if (value.length !== 11) {
          resolve({valid: false, data: {message: 'Kontonummeret må bestå av 11 siffer'}})
        } else if (this.kunde.Landkode === 'NO') {
          // Check modulus 11
          if (!this.checkModulus11(value)) {
            resolve({valid: false, data: {message: 'Kontonummeret er ikke gyldig'}})
          } else {
            resolve({valid: true})
          }
        } else {
          resolve({valid: true})
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeAdresseModal.vue